import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'ui/component/Button.tsx';

export const Ops = () => {
  const { t } = useTranslation();

  return (
    <main className="flex items-center justify-center">
      <div className="absolute inset-0 -z-30 flex flex-col items-center justify-center gap-8 bg-blue-light text-center">
        <img className="w-[300px]" src="/error.svg" alt={t('errors.generic.imageAlt')} />
        <section className="flex flex-col gap-4">
          <h1 className="red">{t('errors.generic.title')}</h1>
          <p>{t('errors.generic.description')}</p>
        </section>
        <Link to={'/'}>
          <Button className="blue">{t('actions.goToHomepage')}</Button>
        </Link>
      </div>
    </main>
  );
};
